var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBookmarkActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.2344 5C30.5339 5 30.8203 5.05948 31.0937 5.17845C31.5234 5.3503 31.8652 5.62128 32.1191 5.99141C32.373 6.36153 32.5 6.77132 32.5 7.22075V32.7792C32.5 33.2287 32.373 33.6385 32.1191 34.0086C31.8652 34.3787 31.5234 34.6497 31.0937 34.8215C30.8464 34.9273 30.5599 34.9802 30.2344 34.9802C29.6094 34.9802 29.069 34.7687 28.6133 34.3457L20 25.9385L11.3867 34.3457C10.918 34.7819 10.3776 35 9.76562 35C9.46615 35 9.17969 34.9405 8.90625 34.8215C8.47656 34.6497 8.13477 34.3787 7.88086 34.0086C7.62695 33.6385 7.5 33.2287 7.5 32.7792V7.22075C7.5 6.77132 7.62695 6.36153 7.88086 5.99141C8.13477 5.62128 8.47656 5.3503 8.90625 5.17845C9.17969 5.05948 9.46615 5 9.76562 5H30.2344Z",
    stroke: "white",
    strokeWidth: 5.15827
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmarkActive);
export default __webpack_public_path__ + "static/media/bookmark_active.e34386447c693da163c08f813e9989c8.svg";
export { ForwardRef as ReactComponent };